export default __webpack_public_path__ + "static/media/Craig-Lugs.0a9c8001.png";